import * as React from 'react';
import { Trans, useTranslation } from "react-i18next";
import { Typography } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import Link from '@mui/material/Link'

const theme = createTheme({
  typography: {
    white: {
      fontFamily: 'Arista-Pro-Light-trial',
      fontSize: '14pt',
      fontWeight: 300,
      color: '#fff',
      lineHeight: '20pt',
      '@media (max-width: 992px)': {
        fontSize: '12pt',
      },
    },
    white_bold: {
      fontFamily: 'Arista-Pro-Fat-trial',
      fontSize: '14pt',
      color: '#fff',
      lineHeight: '25pt',
      '@media (max-width: 992px)': {
        fontSize: '12pt',
      },
    },
    black: {
      fontFamily: 'Arista-Pro-Light-trial',
      fontSize: '14pt',
      fontWeight: 300,
      color: '#000',
      lineHeight: '20pt',
      '@media (max-width: 992px)': {
        fontSize: '12pt',
      },
    },
    green: {
      fontFamily: 'Arista-Pro-Light-trial',
      fontWeight: 300,
      color: '#000',
      lineHeight: '20pt',
      '@media (max-width: 992px)': {
        fontSize: '12pt',
      },
    },
    orange: {
      /*fontFamily: 'Arista-Pro-Light-trial'*/
      /*fontFamily: 'Arista-Pro-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Bold-trial',*/
      fontFamily: 'Arista-Pro-Alternate-Light-trial',
      /*fontFamily: 'Arista-Pro-Alternate-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Bold-trial',*/
      fontSize: '18pt',
      fontWeight: 100,
      color: 'orange',
      lineHeight: '16pt',
      '@media (max-width: 992px)': {
        fontSize: '16pt',
      },
    },
    title_green: {
      fontFamily: 'Arista-Pro-Light-trial',
      /*fontFamily: 'Arista-Pro-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Bold-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Light-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Bold-trial',*/
      fontSize: '12pt',
      fontWeight: 100,
      color: 'green',
      lineHeight: '14pt',
      '@media (max-width: 992px)': {
        fontSize: '12pt',
      },
    },
    normal: {
      fontFamily: 'Arista-Pro-Light-trial',
      /*fontFamily: 'Arista-Pro-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Bold-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Light-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Bold-trial',*/
      fontSize: '12pt',
      lineHeight: '14pt',
      fontWeight: 100,
      /*'@media (max-width: 992px)': {
        fontSize: '20pt',
        lineHeight: '22pt',
      },*/
    },
  },
});

export function AppLink ({ variant, text, url, size, color }) {

  const { t } = useTranslation();

  return (
    <>
      <Typography 
        variant={variant} 
        theme={theme} 
        sx={{fontSize: size, color: color}}>

        <u>
          <a href={url}>{t(text)}</a>
        </u>
        <span> </span>

      </Typography>
    </>
  )
}

export default AppLink